export default {
  companies: [],
  activeCompany: null,
  requestStatus: 'loading'
};
